import { ADMIN_API_URL, LITERALS_URL, NODE_ENV, BACKEND2_API_URL } from './constants/Environment';
import {
    SECTION_CUSTOM_EVENTS,
    // SECTION_FIELDS,
    // SECTION_PARAMETERS,
    SECTION_USERS,
    SECTION_LITERALS,
    // SECTION_WIDGETS,
    // SECTION_FORMS,
    SECTION_APIKEYS,
} from './constants/App';

import {
    AuthenticationManager,
    CacheManager,
    Core,
    ImplementationManager,
    LiteralsManager,
    // ParametersManager,
    SandboxManager,
    // FieldsManager,
    RolesManager,
    SearchManager,
    SectionManager,
    ServerListManager,
    UsersManager,
    // WidgetsManager,
    // ValueListManager,
    // FormsManager,
    ApiKeysManager,
    PermissionsManager,
    DeviceCacheManager,
    // CronsManager,
} from './managers';
import Api from './domain/api';
import ApiBackend2 from './domain/api_backend2';
import LiteralsApi from './domain/literalsApi';

const ApiCFM = new Api(ADMIN_API_URL);
const ApiB2 = new ApiBackend2(BACKEND2_API_URL);
const ApiLiterals = new LiteralsApi(LITERALS_URL);

Core.setAuthenticationManager(new AuthenticationManager(ApiCFM, ApiB2));
Core.setImplementationManager(new ImplementationManager(ApiCFM));
Core.setLiteralsManager(new LiteralsManager(ApiLiterals, ApiCFM));
// Core.setParametersManager(new ParametersManager(ApiCFM));
Core.setSandboxManager(new SandboxManager(ApiCFM));
Core.setCacheManager(new CacheManager(sessionStorage));
// Core.setFieldsManager(new FieldsManager(ApiCFM));
Core.setRolesManager(new RolesManager(ApiCFM));
Core.setSearchManager(new SearchManager(ApiCFM));
Core.setSectionManager(new SectionManager());
Core.setServerListManager(new ServerListManager(ApiCFM));
// Core.setValueListManager(new ValueListManager(ApiCFM));
Core.setUsersManager(new UsersManager(ApiCFM));
// Core.setWidgetsManager(new WidgetsManager(ApiCFM));
// Core.setFormsManager(new FormsManager(ApiCFM));
Core.setApiKeysManager(new ApiKeysManager(ApiCFM));
Core.setPermissionsManager(new PermissionsManager(ApiCFM));
Core.setDeviceCacheManager(new DeviceCacheManager(ApiCFM));
// Core.setCronsManager(new CronsManager(ApiCFM));

// Core.sectionManager.addSectionManager(SECTION_FIELDS, Core.fieldsManager);
// Core.sectionManager.addSectionManager(SECTION_PARAMETERS, Core.parametersManager);
Core.sectionManager.addSectionManager(SECTION_USERS, Core.usersManager);
Core.sectionManager.addSectionManager(SECTION_LITERALS, Core.literalsManager);
// Core.sectionManager.addSectionManager(SECTION_WIDGETS, Core.widgetsManager);
// Core.sectionManager.addSectionManager(SECTION_FORMS, Core.formsManager);
Core.sectionManager.addSectionManager(SECTION_APIKEYS, Core.ApiKeysManager);

const isProduction = NODE_ENV === 'production';

export default isProduction;
